import React from "react";
import Card from "./Card";

export default function SearchJSX(props) {
  const handelClick = () => {
    props.handelClick();
  };

  return (
    <>
      {/* Check if there are no search results */}
      {Object.keys(props.searchResult).length === 0 ? (
        <div align="center">
          <h4
            className="mt-3 fw-bold"
            style={{ fontFamily: "Poppins", color: "red" }}
          >
            NO SEARCH RESULT
          </h4>
          <hr className="search-hr" />
        </div>
      ) : (
        <div align="center">
          {/* Display search result title */}
          <h4 className="green mt-3 fw-bold" style={{ fontFamily: "Poppins" }}>
            SEARCH RESULT
          </h4>
          <hr className="search-hr" />
          <div className="container__main row">
            {/* Iterate over each search result and render a Card component */}
            {props.searchResult?.map((rec, index) => (
              <Card
                rec={rec}
                key={rec.animeId}
                ep="false" // Pass the 'ep' prop as 'true' to display episode information
                handelClick={handelClick}
                animationDelay={`${index * 0.1}s`}
              />
            ))}
          </div>
          <hr className="search-hr" />
        </div>
      )}
    </>
  );
}
